module.exports = __webpack_public_path__ + "static/media/Trips2.c176ee07.PNG";